export const kAppStoreUrl = 'https://itunes.apple.com/ru/app/straus/id1438722558?mt=8';
export const kGooglePlayUrl = 'https://play.google.com/store/apps/details?id=straus.mobile';
